import { Checkbox } from "primereact/checkbox"
import { classNames } from "primereact/utils"
import { useEffect } from "react"

const _props ={
    id: '',
    field: {},
    fieldState: {}
}
export function AppCheckbox(props = _props){
    useEffect(()=>{
       if(props.field.value === undefined){
        props.field.onChange(false)
       }
    },[])



    return <Checkbox inputId={props.field.name} onChange={(e) => props.field.onChange(e.checked)}
     checked={props.field.value} 
     disabled={!props.controlConfig.editable}
     className={classNames({ 'p-invalid': props.fieldState.invalid })} />
    
}